import { render, staticRenderFns } from "./AddVideoResource.vue?vue&type=template&id=18dc5ba8&scoped=true&"
import script from "./AddVideoResource.vue?vue&type=script&lang=js&"
export * from "./AddVideoResource.vue?vue&type=script&lang=js&"
import style0 from "./AddVideoResource.vue?vue&type=style&index=0&id=18dc5ba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc5ba8",
  null
  
)

export default component.exports